import { all, fork } from 'redux-saga/effects';
import UserReducerSaga from './UserReducer/index';

export default function* rootSaga() {
  yield all([fork(UserReducerSaga)]);
}
